import React, { Dispatch, useCallback, useReducer } from "react";
import { RecadastramentoStepForm } from "../config/RecadastramentoStepForm";
import FormBase from "../forms/FormBase";
import Professional from "../models/Professional";
import { Actions, IRecadastramentoState, initialState, reducer, getStateFormPropertyByName } from "./reducers/RecadastramentoReducer";
import FormFieldAttachmentBase, { FieldAttachment } from "../forms/FormFieldAttachmentBase";
import ContextBase, { EAttachmentType } from "./ContextBase";
import ProfissionalService from "../services/ProfessionalService";
import SucessDataService from "../services/SuccessDataService";
import { ReRegistrationAttachmentFormItem } from "../forms/recadastramento/ReRegistrationAttachmentForm";
import ProfessionalAttachmentService from "../services/ProfessionalAttachmentService";

interface IRecadastramentoContextProps {
  state: IRecadastramentoState;
  dispatch: Dispatch<Actions>;
  nextStep: () => void;
  validateCurrentForm: () => Array<string>;
  handleSetRequestIdAndProfessionalId: (requestEncriptId: string, professionalEncriptId: string) => void;
  updateFile: (name: string, form: FormBase, fieldAttachment: FieldAttachment, formField: FormFieldAttachmentBase) => void;
  deleteFile: (name: string, form: FormBase, fieldAttachment: FieldAttachment, formField: FormFieldAttachmentBase) => void;
  updateFileDynamic: (name: string, form: FormBase, fieldAttachment: FieldAttachment, formField: ReRegistrationAttachmentFormItem) => void;
  deleteFileDynamic: (name: string, form: FormBase, formField: ReRegistrationAttachmentFormItem, fieldAttachment: FieldAttachment) => void;
}

export const RecadastramentoContext = React.createContext({} as IRecadastramentoContextProps);

export function RecadastramentoStoreProvider(props: any) {

  const [state, dispatch] = useReducer(reducer, initialState);

  //Método responsavel por avançar as etapas e criar um profissional quando não existir um
  const nextStep = async () => {
    try {

      //Pular a etapa de guia
      if (state.CurrentStep === 1) {
        ContextBase.setLoading(dispatch, true);
        await loadingFormFieldsFromDatabase(state.CurrentStep + 1);

        return;
      }

      //Apresenta o ícone de loading no botão de avançar
      ContextBase.setLoading(dispatch, true);

      //Cria ou busca no state um profissional
      let localProfessional = await createOrGetProfessionalDefault(dispatch, state) as Professional;

      //Realiza a chamada genérica das APIs que insere ou atualiza os dados do formulário
      await callInsertOrUpdateApiForms(RecadastramentoStepForm, state, localProfessional, dispatch, (step, state) => { return getStateFormPropertyByName(step, state) });



    } catch (error) { }

  };

  //Método responsável por realizar o upload de arquivos
  const updateFile = async (name: string, form: FormBase, fieldAttachment: FieldAttachment, formField: FormFieldAttachmentBase) => {

    const formData = new FormData();
    formData.append("eAttachmentRecadastramento", formField.TypeEnum.toString());
    formData.append("file", fieldAttachment.File);

    await ContextBase.updateloFile(dispatch, state.Professional, formData, fieldAttachment, name, form, EAttachmentType.Recadastramento);
  };

  //Método responsável por deletar arquivos
  const deleteFile = async (name: string, form: FormBase, fieldAttachment: FieldAttachment) => {
    await ContextBase.deleteFile(dispatch, fieldAttachment, name, form);
  };

  //Método responsável por realizar o upload de arquivos
  const updateFileDynamic = async (name: string, form: FormBase, fieldAttachment: FieldAttachment, formField: ReRegistrationAttachmentFormItem) => {

    const formData = new FormData();
    formData.append("AttachmentTypeId", formField.AttachmentTypeId.toString());
    formData.append("file", fieldAttachment.File);

    await ProfessionalAttachmentService.updateProfessionalAttachmentReRegistration(formData, state.Professional.Id)
      .then((success) => {
        fieldAttachment.Id = success.data.encriptId;

        dispatch({
          type: "UPDATE_FORM_ATTACHMENT_DYNAMIC",
          payload: { name, form, value: fieldAttachment, subType: "UpdateId", id: fieldAttachment.Id, reRegistrationAttachmentFormItem: formField },
        });
      })
      .catch((error) => {
        dispatch({
          type: "UPDATE_FORM_ATTACHMENT_DYNAMIC",
          payload: {
            name,
            form,
            value: fieldAttachment,
            subType: "Error",
            reRegistrationAttachmentFormItem: formField,
            errorMessage: error.response !== undefined ? error.response.data : "Não foi possível executar o upload do arquivo."
          },
        });
      });

    //await ContextBase.updateloFile(dispatch, state.Professional, formData, fieldAttachment, name, form, EAttachmentType.Recadastramento);
  };

  //Método responsável por deletar arquivos
  const deleteFileDynamic = async (name: string, form: FormBase, fieldAttachmentItem: ReRegistrationAttachmentFormItem, fieldAttachment: FieldAttachment) => {

    if (fieldAttachment.Id === "") {
      dispatch({
        type: "UPDATE_FORM_ATTACHMENT_DYNAMIC",
        payload: {
          name,
          form,
          value: fieldAttachment,
          reRegistrationAttachmentFormItem: fieldAttachmentItem,
          subType: "Delete",
          id: fieldAttachment.Id,
        },
      });
    } else {

      dispatch({
        type: "UPDATE_FORM_ATTACHMENT_DYNAMIC",
        payload: {
          name,
          form,
          value: fieldAttachment,
          reRegistrationAttachmentFormItem: fieldAttachmentItem,
          subType: "Loading",
          loading: true,
          id: fieldAttachment.Id,
        },
      });


      await ProfessionalAttachmentService.deleteAttachment(fieldAttachment.Id)
        .then((success) => {
          dispatch({
            type: "UPDATE_FORM_ATTACHMENT_DYNAMIC",
            payload: {
              name,
              form,
              value: fieldAttachment,
              reRegistrationAttachmentFormItem: fieldAttachmentItem,
              subType: "Delete",
              id: fieldAttachment.Id,
            },
          });

          dispatch({
            type: "UPDATE_FORM_ATTACHMENT_DYNAMIC",
            payload: {
              name,
              form,
              value: fieldAttachment,
              reRegistrationAttachmentFormItem: fieldAttachmentItem,
              subType: "Loading",
              loading: false,
              id: fieldAttachment.Id,
            },
          });
        })
        .catch((error) => {
          dispatch({
            type: "UPDATE_FORM_ATTACHMENT_DYNAMIC",
            payload: {
              name,
              form,
              reRegistrationAttachmentFormItem: fieldAttachmentItem,
              value: fieldAttachment,
              subType: "Error",
              errorMessage: error.response !== undefined ? error.response.data : "Não foi possível deletar o arquivo.",
            },
          });

          dispatch({
            type: "UPDATE_FORM_ATTACHMENT_DYNAMIC",
            payload: {
              name,
              form,
              reRegistrationAttachmentFormItem: fieldAttachmentItem,
              value: fieldAttachment,
              subType: "Loading",
              loading: false,
              id: fieldAttachment.Id,
            },
          });
        });
    }
  };

  //Método responsavel por criar um profissional caso ele não exista no state.
  //Quando o profissional existir no state, ele é retornado
  const createOrGetProfessionalDefault = async (dispatch: any, state: IRecadastramentoState) => {

    let localProfessional = Professional.NewInstance();

    if (state.Professional === null || state.Professional.Id === "" || state.Professional.Id === null) {

      if (state.PersonalDataForm.ValidateToGoNextStep() === "") {
        try {
          const response = await ProfissionalService.postInsertOrUpdateProfissional(state.PersonalDataForm.getJsonObjet(), "");

          localProfessional = new Professional(response.encriptId, response.name);

          dispatch({
            type: "SET_PROFESSIONAL",
            payload: {
              response: response
            },
          });

        } catch (error: any) {
          ContextBase.goToNextStepWithLoading(dispatch, [error.response.data], false);
        }
      }
    } else {
      localProfessional = state.Professional;
    }

    return localProfessional;
  };


  //Método responsável por realizar o upload de arquivos
  const validateCurrentForm = (): Array<string> => {

    var formMessagesError = new Array<string>();

    RecadastramentoStepForm.forEach(function (stepConfig) {
      if (stepConfig.key === state.CurrentStep) {
        stepConfig.steps.forEach(function (step: any) {
          var form = getStateFormPropertyByName(step.name, state) as FormBase;
          let message = form.ValidateToGoNextStep(state);
          if (message !== "" && ((formMessagesError.length === 0 && !stepConfig.validateAllForms) || stepConfig.validateAllForms)) {
            formMessagesError.push(message);
          }
        });
      }
    });

    if (formMessagesError.length > 0) {
      dispatch({
        type: "GO_TO_NEXT_STEP",
        payload: {
          messagesError: formMessagesError
        },
      });

      dispatch({
        type: "LOADING",
        payload: {
          processing: false
        },
      });
    }

    return formMessagesError;
  };

  const callInsertOrUpdateApiForms = (steps: any[], state: any, professional: Professional, dispatch: any, getForm: (name: string, state: any) => {}) => {

    try {

      var formMessagesError = validateCurrentForm();

      // Caso o formulário não tenha nenhum erro, o sistema chama as APIs vinculadas a cada formulário
      if (formMessagesError.length === 0) {

        steps.forEach(function (step: any) {

          if (step.key === state.CurrentStep) {
            let promises: any[] = [];

            step.steps.forEach(async function (step: any) {
              var form = getForm(step.name, state) as FormBase;
              promises.push(form.CallInsertOrUpdateApi(professional));
            });

            Promise.all(promises).then(async () => {

              //Ultima Etapa
              if (state.CurrentStep === steps.length) {

                const response = await SucessDataService.postFinishForm(professional.Id);

                dispatch({
                  type: "LOADING",
                  payload: {
                    processing: false
                  },
                });


                dispatch({
                  type: "SET_PROTOCOL",
                  payload: {
                    response: response
                  },
                });

              } else {
                await loadingFormFieldsFromDatabase(state.CurrentStep + 1);
              }
            })
              .catch((errors) => {

                dispatch({
                  type: "GO_TO_NEXT_STEP",
                  payload: {
                    messagesError: [errors.response.data]
                  },
                });

                dispatch({
                  type: "LOADING",
                  payload: {
                    processing: false
                  },
                });

              });
          }
        });
      }  
    } catch (error) { }

  };

  //Método responsável por apresentar ou não o ícone de loading
  const loadingFormFieldsFromDatabase = async (stepKey: number) => {

    try {

      RecadastramentoStepForm.forEach(function (step: any) {

        if (step.key === stepKey) {
          let promises: any[] = [];

          step.steps.forEach(async function (step: any) {
            var form = getStateFormPropertyByName(step.name, state) as FormBase;

            if (form.PreloadFormFromApi && state.Request) {
              promises.push(form.PreloadFormFromApi(state.Request.Id));
            }
          });

          Promise.all(promises).then(async () => {
            ContextBase.goToNextStepWithLoading(dispatch, [], false);

          }).catch((errors) => {
            console.log(errors);

            dispatch({
              type: "GO_TO_NEXT_STEP",
              payload: {
                messagesError: [errors.response.data]
              },
            });

            dispatch({
              type: "LOADING",
              payload: {
                processing: false
              },
            });

          });
        }
      });
    } catch (error) {

    }

  };


  const handleSetRequestIdAndProfessionalId = useCallback(async (requestEncriptId: string, professionalEncriptId: string) => {
    if (requestEncriptId !== undefined && requestEncriptId !== null) {
      state.Request.Id = requestEncriptId;
    }

    if (professionalEncriptId !== undefined && professionalEncriptId !== null) {
      //state.Professional.Id = professionalEncriptId;

       dispatch({
            type: "SET_PROFESSIONAL",
            payload: {
              response: {encriptId : professionalEncriptId}
            },
          });
    }
  }, [state.Request, state.Professional]);


  const value = {
    state,
    dispatch,
    nextStep,
    updateFile,
    deleteFile,
    validateCurrentForm,
    updateFileDynamic,
    deleteFileDynamic,
    handleSetRequestIdAndProfessionalId
  };

  return (
    <RecadastramentoContext.Provider value={value}>
      {props.children}
    </RecadastramentoContext.Provider>
  );
}

